// extracted by mini-css-extract-plugin
module.exports = {"navHeader":"LoginHeader_navHeader__30-Sr","logoLink":"LoginHeader_logoLink__fSMjQ","description":"LoginHeader_description__1Piqf","schoolName":"LoginHeader_schoolName__3vafr"};